import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VonalkodTesztlapDto extends IdentifiableDto {
	constructor() {
		super();
		this.feltoltoTesztlapNev = null;
		this.csomagNev = null;
		this.vonalkodVizsga = null;
		this.vonalkodVizsgazo = null;
		this.hibaXML = null;
		this.feltoltesIdeje = null;
	}

	setup(props) {
		super.setup(props);
		this.feltoltoTesztlapNev = props.feltoltoTesztlapNev;
		this.csomagNev = props.csomagNev;
		this.vonalkodVizsga = props.vonalkodVizsga;
		this.vonalkodVizsgazo = props.vonalkodVizsgazo;
		this.hibaXML = props.hibaXML;
		this.feltoltesIdeje = props.feltoltesIdeje;
		return this;
	}
}

export default VonalkodTesztlapDto;
